export interface Barcode {
    id_stampa_log: number;
    print_hash: string;
    fg_active: number;
    validity_date: Date;
    stock_document_id: number;
}

export interface Person {
    address: string;
    name: string;
    last_update: Date;
    company_code: string;
    fiscal_code: string;
    vat_number: string;
    full_name: string;
    last_name: string;
    zip_code: string;
    flag_vat_number: string;
    council_id: string;
    subject_id: number;
    province_code: string;
    council_name: string;
}

export interface DeliveryNote {
    fg_active: number;
    supplier_id: number | null;
    supplier: Person | null;
    dn_ref: string;
    dn_date: number;
    stock_item_document_id: number;
    dn_file_id: number | null;
    stock_document_id: number;
    id_stampa_log: number | null;
    print_hash: string | null;
    recipient: Person | null;
    recipient_id: number | null;
    item_attachment_id: number;
}

export interface Attachment {
    attachment_description: string | null;
    attachment_type: string;
    custom_repository: number | null;
    expiry_date: number | null;
    fg_active: number | null;
    fg_expired: number | null;
    file_repository_id: number | null;
    issue_date: number | null;
    item_attachment_id: number | null;
    recipient: Person | null;
    recipient_id: number | null;
    stock_item_document_id: number | null;
    stock_item_id: number | null;
    supplier: Person | null;
    supplier_id: number | null;
    validity_date: number | null;
    stock_document_id: number;
    mime_type?: any;
    file_name?: any;
}

export interface Movement {
    last_update: Date;
    item_name: string;
    sco_unit_measure: string;
    item_id: number;
    physical_quantity: string;
    quantity: number;
    unit_measure: string;
    ds_unit_measure: string;
    quantity_abs: number;
    warehouse_id: number;
    warehouse_description: string;
    operation_type: string;
    production_date: Date;
    stocked_lot_id: number;
    operation_date: Date;
    stock_item_id: number;
    unit_price: number;
    unimis_family: string;
    barcodes: Barcode[];
    delivery_notes: DeliveryNote[];
    attachments: MovementAttachment[];
    expire_date: Date;
    stocked_lot_number: string;
    ds_unimis_family: string;
    stock_full_text: string;
}

export interface MovementAttachment {
    stock_document_id: number;
    file_repository_id: number;
    attachment_type: string;
    attachment_description?: string;
    issue_date?: number;
    validity_date?: number;
    expiry_date?: number;
    recipient_id?: number;
    supplier_id?: number;
    stock_item_id: number;
    item_attachment_id: number;
    fg_expired: number;
    stock_item_document_id: number;
    custom_repository: number;
    mime_type?: string;
    supplier?: string;
    recipient?: string;
    file_name?: string;
    fg_active: number;
}

export interface MovementType {
    is_load: number;
    operation_desc_key: string;
    operation_type: string;
    operation_desc: string;
}

export interface MovementOut {
    operation_date: Date | null;
    quantity: number | undefined;
    sco_unit_measure: string | undefined;
}

export function toMovementOut(e: Movement): MovementOut {
    return {
        operation_date: e.operation_date ? e.operation_date : null,
        quantity: e.quantity ? e.quantity : undefined,
        sco_unit_measure: e.sco_unit_measure ? e.sco_unit_measure : undefined,
    }
}

export const ACTIVITY_TYPES = [
    {
        is_load: 1,
        operation_desc_key: "warehouse.operation_type.LOAD_ACTIVITY",
        operation_type: "LOAD_ACTIVITY",
        operation_desc: ""
    },
    {
        is_load: 0,
        operation_desc_key: "warehouse.operation_type.UNLOAD_ACTIVITY",
        operation_type: "UNLOAD_ACTIVITY",
        operation_desc: ""
    }
];
